import { useGraphQLQuery } from '@opengov/bnp-core';
import { IPublicationNavMenuStory } from '@opengov/stories-shared/types';

import { graphql } from '../../../../../gql-generated/hasura';
import {
  GetMenuStoriesForOnlinePublicationQuery,
  GetMenuStoriesForOnlinePublicationQueryVariables
} from '../../../../../gql-generated/hasura/graphql';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { useToast } from '../../../Toast/context/useToast.context';

import {
  MenuStoriesKeyParams,
  setupOnlinePublicationQueryKeys
} from './setupOnlinePublicationQueryKeys';

const GetMenuStoriesForOnlinePublicationDocument = graphql(`
  query GetMenuStoriesForOnlinePublication($id: uuid!) {
    menuStories: publicationNavigationMenuStories(
      where: { menuId: { _eq: $id } }
      order_by: { order: asc }
    ) {
      order
      menuId
      id
      displayName
      createdBy
      createdAt
      storyId
      updatedAt
      story {
        _id
        order
        title
      }
    }
  }
`);

export type UseMenuStoriesForMenuIdParams = MenuStoriesKeyParams | null;

export function useMenuStoriesForMenuId(
  params: UseMenuStoriesForMenuIdParams,
  errorMessage: string
) {
  const { toggleToast } = useToast();

  return useGraphQLQuery<
    GetMenuStoriesForOnlinePublicationQuery,
    GetMenuStoriesForOnlinePublicationQueryVariables,
    IPublicationNavMenuStory[]
  >({
    queryKey: params
      ? setupOnlinePublicationQueryKeys.menuStories(params)
      : ([...setupOnlinePublicationQueryKeys.all, 'menuStories', 'disabled'] as const),
    document: GetMenuStoriesForOnlinePublicationDocument,
    url: HASURA_SERVICE_URL,
    variables: params ? { id: params.menuId } : { id: '' },
    options: {
      enabled: params !== null,
      onError: () => {
        toggleToast({ title: errorMessage, severity: 'error' });
      },
      select: (data: GetMenuStoriesForOnlinePublicationQuery): IPublicationNavMenuStory[] =>
        (data.menuStories ?? []) as unknown as IPublicationNavMenuStory[]
    }
  });
}
